module.exports = __webpack_public_path__ + "static/media/interviewIllustration.184f039d.png";